import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { theme } from '../../../domain/theme';
import { removeSpacesFromHtmlHref } from '../../../domain/utils/stringUtils';
import { ParagraphWrapper } from '../ParagraphWrapper';
import { Ad } from '../../responsive/atoms/Ad';
import { AuthorBoxNotes } from '../AuthorBoxNotes';

const styles = {
  container: css`
    h2.h3 {
      font-size: ${theme.font.size('l')};
    }
  `,
  ad: css`
    padding-bottom: 1.5em;
    ${theme.mq.tablet} {
      display: none;
    }
  `,
  adTeads: css`
    ${theme.mq.tablet} {
      display: none;
    }
  `
};

const ContentInner = ({ data, content, ads }) => {
  // @todo remove after all articles are re-exported
  if (data.styleTemplate === 'with-border') {
    return <AuthorBoxNotes data={data} content={content} />;
  }
  if (data.content) {
    let dataString = data.content.value;
    dataString = removeSpacesFromHtmlHref(dataString);

    if (content.branded) {
      dataString = dataString.replace(
        'rel="nofollow noopener noreferrer"',
        'rel="nofollow noopener sponsored"',
        dataString
      );
    }

    const dataStringParts = dataString
      .replaceAll('<p>', '<p >')
      .split('<p ')
      .map((part, index) => {
        return index !== 0
          ? `<p data-paragraph-id="${data.id}-${index}" ${part}`.replace(
              ' >',
              '>'
            )
          : part;
      })
      .filter(part => part.trim() !== '');

    const renderStrings = [];
    dataStringParts.forEach((part, index) => {
      const paragraphId = `${data.id}-${index}`;

      const paragraphComponent = (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={paragraphId}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: part }}
        />
      );

      let ad;
      let adComponent;
      if (ads?.[paragraphId]) {
        ad = ads[paragraphId];
        adComponent = (
          <div
            css={ad.isTeads ? styles.adTeads : styles.ad}
            key={`${paragraphId}-ad`}
          >
            <Ad
              id={
                ad.isTeads
                  ? `teads_mobile__${ad.adIndex}_${content.id}`
                  : `article__${ad.adIndex}_${content.id}`
              }
              content={content}
              refresh={!ad.isTeads}
              collapseEmptyDiv={ad.isTransported}
            />
          </div>
        );
      }

      if (ad) {
        if (ad.isTeads) {
          renderStrings.push(adComponent);
          renderStrings.push(paragraphComponent);
        } else {
          renderStrings.push(paragraphComponent);
          renderStrings.push(adComponent);
        }
      } else {
        renderStrings.push(paragraphComponent);
      }
    });

    return (
      <div className="paragraph" css={styles.container}>
        {renderStrings}
      </div>
    );
  }
  return <div />;
};
/* eslint-enable react/no-danger */

ContentInner.defaultProps = {
  content: undefined,
  ads: undefined
};

ContentInner.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  content: PropTypes.objectOf(PropTypes.any),
  ads: PropTypes.objectOf(PropTypes.any)
};

export const Content = ParagraphWrapper(ContentInner);
